// extracted by mini-css-extract-plugin
export default {"container":"DashboardPage_container__jPBvi","leaving":"DashboardPage_leaving__fSDWN"};